import type { GetTweetsType } from './getTweetsType';
import type { GetTweetsSortBy } from './getTweetsSortBy';
import type { GetTweetsSortDirection } from './getTweetsSortDirection';

export type GetTweetsParams = {
/**
 * 검색어 (선택적)
 */
query?: string;
/**
 * 트윗 타입
- FOR_YOU: 추천 트윗
- USER: 특정 사용자의 트윗
- FOLLOW: 팔로우한 사용자들의 트윗
- DETAIL: 특정 트윗의 상세 정보와 관련 트윗 (tweetId 파라미터 필수)

 */
type?: GetTweetsType;
/**
 * 특정 사용자의 트윗을 조회할 때 사용하는 사용자 ID (type이 OTHER일 경우 필수)
 */
userId?: number;
/**
 * 상세 조회할 트윗의 ID (type이 DETAIL인 경우 필수)
- DETAIL 타입 조회 시 해당 트윗과 관련된 트윗들을 조회합니다.

 */
tweetId?: number;
/**
 * 해시태그로 필터링 (선택 사항)
 */
hashtag?: string;
/**
 * 조회 시작 날짜 (ISO 8601 형식, 선택 사항)
 */
startDate?: string;
/**
 * 조회 종료 날짜 (ISO 8601 형식, 선택 사항)
 */
endDate?: string;
/**
 * 정렬 기준 필드
 */
sortBy?: GetTweetsSortBy;
/**
 * 정렬 방향
 */
sortDirection?: GetTweetsSortDirection;
/**
 * 페이지 번호 (0부터 시작)
 */
page?: number;
/**
 * 페이지 크기
 */
size?: number;
};
